// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgPeakUsageIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path d="M17.228 18.934H6.12q-.527 0-.758-.459t.073-.888l3.476-4.874q.237-.34.599-.524.36-.184.785-.184h2.916l4.226-4.93q.386-.447.941-.244t.555.8v9.597q0 .709-.499 1.207a1.65 1.65 0 0 1-1.207.5Zm-8.648-8.43-2.298 3.237a.82.82 0 0 1-.552.35.83.83 0 0 1-.637-.154.82.82 0 0 1-.35-.555.83.83 0 0 1 .155-.639L7.21 9.521A1.68 1.68 0 0 1 8.599 8.8h2.916l3.005-3.51a.8.8 0 0 1 .578-.299.84.84 0 0 1 .62.21.8.8 0 0 1 .298.578.84.84 0 0 1-.21.62L12.8 9.907a1.54 1.54 0 0 1-.578.445 1.7 1.7 0 0 1-.708.152z" />
  </g>
);
export default SvgPeakUsageIcon;
SvgPeakUsageIcon.displayName = 'SvgPeakUsageIcon';
